import React from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { VStack } from "@chakra-ui/react";
import { BreadcrumbItem, BreadcrumbLink } from "@chakra-ui/breadcrumb";
import { PageHeading } from "../../components/PageHeading/PageHeading";
import { PageContent } from "../../components/PageContent/PageContent";
import { BusinessBreadcrumbs } from "../../components/Breadcrumbs/BusinessBreadcrumbs";
import { useAdminApiClient } from "../../hooks/useApiClient";
import { useToast } from "../../hooks/useToast";
import { GeoLocationGroupDetailForm } from "../../forms/GeoLocationGroupDetailForm";
import { CherryHubAdminApi } from "../../api/adminApiModels";

export const GeoLocationGroupCreate: React.FC = () => {
  const { businessId } = useParams();
  const navigate = useNavigate();
  const apiClient = useAdminApiClient();
  const { showSuccessToast, showErrorToast } = useToast();

  const backToConfig = () =>
    navigate(`/admin/businesses/${businessId}/geo-fence-configuration`);

  const onSuccess = (geoLocationGroup: CherryHubAdminApi.GeoLocationGroup) => {
    showSuccessToast("Geo Location Group created.");
    if (geoLocationGroup.Meta?.Id) {
      navigate(
        `/admin/businesses/${businessId}/geo-fence-configuration/geo-location-groups/${geoLocationGroup.Meta.Id}`
      );
    } else {
      backToConfig();
    }
  };

  const onFailure = (message?: string) => {
    showErrorToast(message ?? "Failed to create Geo Location Group.");
  };

  return (
    <>
      <PageHeading>
        <PageHeading.Title>Create Geo Location Group</PageHeading.Title>
      </PageHeading>
      <PageContent>
        <VStack alignItems="flex-start" width="100%" spacing={6}>
          <BusinessBreadcrumbs variant="pageHeading">
            <BreadcrumbItem>
              <BreadcrumbLink
                as={RouterLink}
                to={`/admin/businesses/${businessId}/geo-fence-configuration`}
              >
                Geo-Fence Configuration
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <BreadcrumbLink
                as={RouterLink}
                to={`/admin/businesses/${businessId}/geo-fence-configuration/geo-location-groups/new`}
              >
                New Geo Location Group
              </BreadcrumbLink>
            </BreadcrumbItem>
          </BusinessBreadcrumbs>

          {businessId && (
            <GeoLocationGroupDetailForm
              apiClient={apiClient}
              businessId={businessId}
              onCancel={backToConfig}
              onSuccess={onSuccess}
              onFailure={onFailure}
            />
          )}
        </VStack>
      </PageContent>
    </>
  );
};
